export default __webpack_public_path__ + "static/media/Bodies and Souls _ Lawrence Peart 230.3df1a4e9.jpg";